



















import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'registry-page',
  components: {},
})
export default class RegistryPage extends Vue {
}
